<template>
  <div class="eventConfig-page">
    <!-- <ioc-tab-group
      ref="tabs"
      :class="eventType.prop"
      :option="tabOption"
      @change="handleChange"
    ></ioc-tab-group> -->
    <div class="eventConfig-search">
      <el-form
        style="transition: all 500ms linear"
        :class="showSearch ? 'expand searchContent' : 'up searchContent'"
        ref="searchForm"
        :inline="true"
        :model="queryForm"
        class="demo-form-inline"
      >
        <!-- 子系统 -->
        <el-form-item :label="$t('deviceAccess.label.subSystem')">
          <el-select
            v-model="queryForm.subSystem"
            :placeholder="$t('deviceAccess.placeholder.select')"
            clearable
            class="operator__input"
            @change="chooseSubsystem"
          >
            <el-option
              v-for="item in subSystemOptions"
              :key="'sub' + item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 处理方式 -->
        <el-form-item :label="$t('deviceAccess.label.handle')">
          <el-select
            v-model="queryForm.processType"
            :placeholder="$t('deviceAccess.placeholder.select')"
            clearable
            class="operator__input"
            @change="chooseMethods"
          >
            <el-option
              v-for="item in handTypeOptions"
              :key="'ITEMKEY' + item.ITEMKEY"
              :label="item.ITEMVALUE"
              :value="item.ITEMKEY"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 告警级别 -->
        <el-form-item :label="$t('deviceAccess.label.grade')">
          <el-select
            v-model="queryForm.alarmLevel"
            :placeholder="$t('deviceAccess.placeholder.select')"
            clearable
            class="operator__input"
            @change="chooseLevel"
          >
            <el-option
              v-for="item in alarmLevOptions"
              :key="'alarmLev' + item.ITEMKEY"
              :label="item.ITEMVALUE"
              :value="item.ITEMKEY"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 告警类型 -->
        <el-form-item :label="$t('deviceAccess.label.alarmType')">
          <el-select
            v-model="queryForm.eventAlarmType"
            :placeholder="
              !queryForm.subSystem || !queryForm.processType
                ? '请先选择子系统和处理方式'
                : '请选择告警类型'
            "
            clearable
            :disabled="!queryForm.subSystem || !queryForm.processType"
            class="operator__input"
            @change="chooseType"
          >
            <el-option
              v-for="item in alarmTypeOptions"
              :key="'alarmType' + item.eventAlarmId"
              :label="item.itemValue"
              :value="item.eventAlarmType"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div style="height: 41px; position: absolute; right: 20px">
        <el-button class="query-btn" type="primary" @click="getEveCon">{{
          $t("accountGroup.button.query")
        }}</el-button>
        <el-button type="info" @click="resetForm">{{
          $t("accountGroup.button.reset")
        }}</el-button>
        <el-button
          v-show="showExpandBtn"
          type="text"
          size="medium"
          style="color: #407aee; margin-left: 25px"
          @click="showSearch = !showSearch"
          :icon="showSearch ? 'el-icon-arrow-up ' : 'el-icon-arrow-down'"
          >{{ !showSearch ? "展开" : "收起" }}</el-button
        >
      </div>
    </div>
    <div class="table-container">
      <ioc-table
        ref="crud"
        :data="deviceData"
        :option="tableOption"
        :page="eveCofPage"
        @current-change="changePage"
        @size-change="changeSize"
      >
        <template slot="menuLeft">
          <el-button
            type="primary"
            v-if="eventType.typeId === '2'"
            size="small"
            icon="el-icon-plus"
            @click="addFireEventConfig"
            >新增
          </el-button>
        </template>
        <template slot="menuLeft">
          <el-button
            type="primary"
            @click="
              () => {
                $router.push('/deviceaccess/fireAlarmInhibition');
              }
            "
            >告警抑制
          </el-button>
        </template>
        <!-- 定制操作栏按钮 -->
        <template slot="menu" slot-scope="scope">
          <el-tooltip
            v-if="!scope.row.isEdit"
            class="item"
            effect="dark"
            :content="$t('deviceAccess.button.modify')"
            placement="top"
            popper-class="tooltip-draw"
          >
            <el-button
              type="text"
              icon="el-icon-edit"
              @click="handleEdit(scope.row, scope.index)"
            ></el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="删除"
            v-if="scope.row.multiAlarmType == '2' && eventType.typeId === '2'"
            placement="top"
            popper-class="tooltip-draw"
          >
            <el-button
              type="text"
              icon="iconfont icon-shanchu"
              @click="handleDel(scope.row, scope.index)"
            ></el-button>
          </el-tooltip>
          <!-- <el-tooltip
            v-if="eventType.typeId === '1'"
            class="item"
            effect="dark"
            content="派发配置"
            placement="top"
            popper-class="tooltip-draw"
          >
            <el-button
              type="text"
              icon="el-icon-setting"
              @click="configAlarmTaskRule(scope.row)"
            ></el-button>
          </el-tooltip> -->
          <el-button
            v-show="scope.row.isEdit"
            type="text"
            size="small"
            @click="saveInfo(scope.row, scope.index)"
            >{{ $t("deviceAccess.button.save") }}</el-button
          >
          <el-button
            v-show="scope.row.isEdit"
            type="text"
            size="small"
            @click="cancelEdit(scope.row, scope.index)"
            >{{ $t("deviceAccess.button.cancel") }}</el-button
          >
        </template>
        <!-- 处理方式下拉框插槽 -->
        <template slot="processType" slot-scope="scope" v-if="eventType.typeId === '1'">
          <el-select
            v-if="scope.row.isEdit"
            v-model="scope.row.processType"
            :placeholder="$t('deviceAccess.placeholder.select')"
            @change="handTypeChange(scope)"
          >
            <el-option
              v-for="item in handTypeOptions"
              :key="'ITEMVALUE' + item.processType"
              :label="item.ITEMVALUE"
              :value="item.ITEMKEY"
            >
            </el-option>
          </el-select>
          <span v-else>{{ handleEnumeration[scope.row.processType] }}</span>
        </template>

        <!-- 告警类型插槽 -->
        <template slot="eventAlarmId" slot-scope="scope" v-if="eventType.typeId === '1'">
          <el-select
            v-if="scope.row.isEdit"
            v-model="scope.row.eventAlarmId"
            :placeholder="$t('deviceAccess.placeholder.select')"
            @change="eventNameChange(scope.row)"
          >
            <el-option
              v-for="item in scope.row.eventNameOptions"
              :key="'eventAlarmId' + item.eventAlarmId"
              :label="item.itemValue"
              :value="item.eventAlarmId"
            >
            </el-option>
          </el-select>
          <span v-else>{{ scope.row.eventAlarmName }}</span>
        </template>

        <!-- 告警级别插槽 -->
        <template slot="alarmLevel" slot-scope="scope" v-if="eventType.typeId === '1'">
          <el-select
            v-if="scope.row.isEdit"
            v-model="scope.row.alarmLevel"
            :placeholder="$t('deviceAccess.placeholder.select')"
            @change="alarmLevChange"
          >
            <el-option
              v-for="item in alarmLevOptions"
              :key="'TYPEITEMKEY' + item.ITEMKEY"
              :label="item.ITEMVALUE"
              :value="item.ITEMKEY"
            >
            </el-option>
          </el-select>
          <span v-else>{{ levelEnumeration[scope.row.alarmLevel] }}</span>
        </template>
        <!-- 表格列 状态 -->
        <template slot="autoAlarmTask" slot-scope="scope">
          <el-switch
            v-model="scope.row.autoAlarmTask"
            active-value="1"
            inactive-value="0"
            @change="handleUpdateAutoAlarmTask(scope.row)"
          ></el-switch>
          {{ scope.row.$autoAlarmTask }}
        </template>
      </ioc-table>
    </div>
    <fire-event-config
      ref="eventDialog"
      :state="state"
      :originalEventData="allOriginalEventType"
      :processTypeData="handTypeOptions"
      :alarmLevelData="alarmLevOptions"
      @refresh="refreshPage"
    ></fire-event-config>
    <!-- 派发配置弹框 -->
    <config-alarm-task-rule
      ref="configAlarmTaskRuleDialog"
      @refresh="refreshPage"
    ></config-alarm-task-rule>
  </div>
</template>
<script>
import { api } from "../api";
import { Dic } from "$utils";
import utils from "@src/common/utils";
import tableOption from "../config/eventConfigTable";
import fireEventConfig from "../components/VCN/fireEventDialog";
import configAlarmTaskRule from "../components/VCN/configAlarmTaskRule";

export default {
  components: {
    fireEventConfig,
    configAlarmTaskRule,
  },
  data() {
    return {
      showExpandBtn: false,
      showSearch: false,
      // 存储所有原始告警类型
      allOriginalEventType: [],
      // 子系统枚举
      subSystemOptions: [],
      // 处理方式枚举
      handTypeOptions: [],
      //告警级别枚举
      alarmLevOptions: [],
      // 告警类型枚举(通过选择处理方式来获取枚举)
      alarmTypeOptions: [],
      tableOption: tableOption(false),
      // 表格绑定数据
      deviceData: [],
      eveCofPage: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      systemId: "",
      deviceType: "",
      factoryId: "",
      eveTypeArr: {},
      eveTypeKey: "process_",
      // 查询字段
      queryForm: {
        subSystem: "",
        processType: "",
        alarmLevel: "",
        eventAlarmType: "",
      },
      subSystemsList: [4, 13, 14], // _.map(Dic.find("SENU004"), "value"),
      handleEnumeration: {
        1: "创建安全事件告警",
        2: "创建设备故障告警",
        3: "创建事件",
        4: "忽略",
      },
      levelEnumeration: {
        1: "紧急",
        2: "严重",
        3: "一般",
        4: "普通",
      },
      tabOption: {
        column: [
          {
            label: "安防事件",
            prop: "video",
            typeId: "1",
          },
          {
            label: "消防事件",
            prop: "fire",
            typeId: "2",
          },
        ],
      },
      eventType: {},
      state: 1, // 1: 新增 2：修改
    };
  },
  created() {
    this.systemId = this.$route.query.systemId;
    this.deviceType = this.$route.query.deviceType;
    this.factoryId = this.$route.query.factoryId;
    // 默认进入页面选中第一种分类方式
    if (this.$route.query.isFire) this.eventType = this.tabOption.column[1];
    this.eventType = this.tabOption.column[1];

    // 消防子系统 4 13 14
    // this.subSystemsList.forEach((item, index) => {
    //   if (item != 4 && item != 13 && item != 14) {
    //     this.subSystemsList.splice(index, 1);
    //   }
    // });
  },
  mounted() {
    this.animation();
    // 获取子系统枚举值 屏蔽消防子系统
    this.shieldFire();
    this.getDevType();
    if (this.eventType.typeId === "1") {
      this.getEveCon();
    } else {
      this.fireRefresh();
    }
  },
  methods: {
    animation() {
      let that = this;
      let domAry =
        document.querySelector(".searchContent") &&
        document.querySelector(".searchContent").children;
      if (!domAry) {
        return;
      }
      window.onresize = function () {
        that.animation();
      };
      if (domAry[domAry.length - 1].offsetTop != domAry[0].offsetTop) {
        this.showExpandBtn = true;
      } else {
        this.showExpandBtn = false;
      }
    },
    refreshPage() {
      if (this.eventType.typeId === "1") {
        this.shieldFire();
        // 视频事件
        this.tableOption = tableOption(true);
        this.getEveCon();
      } else {
        // 消防事件
        this.fireRefresh();
      }
    },
    // 切换选项卡
    handleChange(column) {
      this.eventType = column;
      if (this.eventType.typeId === "1") {
        this.shieldFire();
        // 视频事件
        this.tableOption = tableOption(true);
        this.getEveCon();
      } else {
        // 消防事件
        this.fireRefresh();
      }
    },
    // 消防事件中的刷新
    fireRefresh() {
      this.tableOption = tableOption(false);
      this.subSystemOptions = [
        {
          label: "消防子系统",
          value: 4,
        },
        {
          label: "电气火灾",
          value: 13,
        },
        {
          label: "可燃气体",
          value: 14,
        },
      ];
      this.queryForm = {
        subSystem: "",
        processType: "",
        alarmLevel: "",
        eventAlarmType: "",
      };
      this.getEveCon();
    },
    // 子系统枚举屏蔽消防子系统
    shieldFire() {
      let list = Dic.find("SENU004");
      console.log(list);
      list.forEach((item, index) => {
        if (item.value == 4 || item.value == 13 || item.value == 14) {
          this.subSystemOptions.push(item);
        }
      });
    },
    //查询事件配置页面中的枚举类型
    getDevType() {
      const params = {
        pageBean: {
          pageNo: this.eveCofPage.currentPage,
          pageSize: this.eveCofPage.pageSize,
        },
      };
      this.$fetch(api.device.vcnConfigureDeviceEventType, params).then((res) => {
        this.handTypeOptions = res.returnObj.vcnProcessType;
        res.returnObj.eventType.forEach((item) => {
          if (item.subSystem == 4) {
            this.allOriginalEventType.push(item);
          }
        });
        this.alarmLevOptions = res.returnObj.vcnGradeType;
        //获取当前所有处理方式对应的事件名称(告警类型)
        // this.getEveType();
      });
    },
    // 查询系统的事件配置
    getEveCon() {
      this.deviceData = [];
      // 判断是第一个tab页面还是第二个页面  参数不同
      const tabParams1 = {
        subSystemList: this.queryForm.subSystem
          ? [this.queryForm.subSystem]
          : this.subSystemsList,
        processType: this.queryForm.processType,
        alarmLevel: this.queryForm.alarmLevel,
        eventAlarmType: this.queryForm.eventAlarmType,
        pageBean: {
          pageNo: this.eveCofPage.currentPage,
          pageSize: this.eveCofPage.pageSize,
        },
      };
      const tabParams2 = {
        subSystemList: this.queryForm.subSystem
          ? [this.queryForm.subSystem]
          : [4, 13, 14],
        processType: this.queryForm.processType,
        alarmLevel: this.queryForm.alarmLevel,
        eventAlarmType: this.queryForm.eventAlarmType,
        pageBean: {
          pageNo: this.eveCofPage.currentPage,
          pageSize: this.eveCofPage.pageSize,
        },
      };
      this.$fetch(
        api.device.vcnQuerySystemConfigure,
        this.eventType.typeId === "1" ? tabParams1 : tabParams2
      ).then((res) => {
        res.returnObj.map((item, index) => {
          const devdata = {
            ...item,
          };
          this.$set(devdata, "systemId", this.systemId);
          this.$set(devdata, "index", index);
          // this.$set(devdata, 'eventNameOptions', this.eveTypeArr[this.eveTypeKey + item.processType]);
          // this.getAlarmTypeByHandle(item.subSystem, item.processType)
          this.$set(devdata, "isEdit", false);
          this.deviceData.push(devdata);
        });
        this.eveCofPage.pageSize = res.page.pageSize;
        this.eveCofPage.total = res.page.totalCount;
        this.eveCofPage.currentPage = res.page.pageNo;
      });
    },
    // 重置按钮绑定事件
    resetForm() {
      this.queryForm = {
        subSystem: "",
        processType: "",
        alarmLevel: "",
        eventAlarmType: "",
      };
      this.getEveCon();
    },
    // 子系统选择
    chooseSubsystem(value) {
      this.queryForm.subSystem = value;
      this.getQueryTypeOptions(value, this.queryForm.processType);
    },
    chooseMethods(value) {
      this.queryForm.processType = value;
      this.getQueryTypeOptions(this.queryForm.subSystem, value);
    },
    // 获取查询条件中的告警类型下拉
    getQueryTypeOptions(subValue, typeValue) {
      const params = {
        subSystem: subValue,
        processType: typeValue,
        parkId: "200000001",
      };

      if (this.queryForm.subSystem) {
        this.$fetch(api.device.vcnConfigureDeviceEunmInfo, params).then((res) => {
          this.alarmTypeOptions = res.returnObj;
        });
      } else {
        this.alarmTypeOptions = [];
      }
    },
    chooseLevel(value) {
      this.queryForm.alarmLevel = value;
    },
    chooseType(value) {
      this.queryForm.eventAlarmType = value;
    },
    // 新增消防事件配置规则
    addFireEventConfig() {
      this.state = 1;
      this.$nextTick(() => {
        this.$refs.eventDialog.open();
      });
    },
    // 表格编辑按钮
    handleEdit(item, index) {
      if (this.eventType.typeId === "1") {
        // 视频事件的修改
        item.isEdit = true;
        const params = {
          subSystem: item.subSystem,
          processType: item.processType,
          parkId: "200000001",
        };
        this.$fetch(api.device.vcnConfigureDeviceEunmInfo, params).then((res) => {
          res.returnObj.map((val) => {
            this.$set(val, "eventAlarmName", val.itemValue);
          });
          console.log(res.returnObj);
          this.$set(item, "eventNameOptions", res.returnObj);
        });
      } else {
        // 消防事件修改
        this.state = 2;
        this.$nextTick(() => {
          this.$refs.eventDialog.open(item);
        });
      }
    },
    handleDel(item, index) {
      const params = {
        ruleIdList: [item.ruleId],
      };
      this.$confirm("您确定删除该条事件配置吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.fire.deleteAlarmEventRule, params).then((response) => {
          if (response && response.success) {
            this.$message({
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.getEveCon();
        });
      });
    },
    // 表格后保存文字
    saveInfo(item, index) {
      item.isEdit = false;
      // console.log("点击保存按钮后的数据++++", item)
      if (item.eventAlarmType === "" && item.processType !== "4") {
        this.$message.error(this.$t("deviceAccess.message.type"));
        this.getEveCon();
        return;
      }
      let queryObj = [
        {
          originalId: item.originalId,
          ruleId: item.ruleId,
          subSystem: item.subSystem,
          processType: item.processType,
          eventAlarmId: item.eventAlarmId,
          eventAlarmType: item.eventAlarmType,
          alarmLevel: item.alarmLevel,
          originalCode: item.originalCode,
        },
      ];
      const params = {
        alarmEventRuleList: queryObj,
      };
      this.$fetch(api.device.vcnUpdateConfigure, params).then((res) => {
        if (res.success === true) {
          this.$message.success(this.$t("deviceAccess.message.editSuccess"));
          this.getEveCon();
        } else if (res.success === false) {
          this.$message.error(this.$t("deviceAccess.message.editFailed"));
        }
      });
    },
    // 表格后面取消按钮
    cancelEdit(item, index) {
      item.isEdit = false;
      this.getEveCon();
    },
    // 处理方式变更
    handTypeChange(data) {
      // console.log('data处理方式+++', data.row);
      const params = {
        subSystem: data.row.subSystem,
        processType: data.row.processType,
        parkId: "200000001",
      };
      if (data.row.processType !== "4") {
        this.$fetch(api.device.vcnConfigureDeviceEunmInfo, params).then((res) => {
          data.row.eventNameOptions = res.returnObj;
          if (data.row.eventNameOptions.length === 0) {
            data.row.eventAlarmName = "";
            data.row.eventAlarmType = "";
            data.row.eventAlarmId = "";
          }
        });
      }
    },
    // 告警类型变更
    eventNameChange(scope) {
      // console.log('scope',scope);
      scope.eventNameOptions.map((item) => {
        if (item.eventAlarmId === scope.eventAlarmId) {
          this.deviceData[scope.index].eventAlarmName = item.itemValue;
          this.deviceData[scope.index].eventAlarmType = item.eventAlarmType;
        }
      });
    },
    // 告警级别变更
    alarmLevChange(value) {
      // console.log(value)
    },

    // 前往输入的页数
    changePage(val) {
      this.eveCofPage.currentPage = val;
      this.getEveCon();
      // this.getDevType();
    },
    changeSize(val) {
      this.eveCofPage.pageSize = val;
      this.getEveCon();
      // this.getDevType();
    },
    // 获取事件名称(告警类型)
    getEveType() {
      let allArr = [];
      this.handTypeOptions.map((item) => {
        allArr.push(
          new Promise((resolve) => {
            this.getEveName(item.ITEMKEY).then((res) => {
              if (res) {
                this.eveTypeArr[this.eveTypeKey + item.ITEMKEY] = res;
              }
              resolve(true);
            });
          }) //promise结束
        ); //push结束
      }); //map结束
      Promise.all(allArr).then(() => {
        this.getEveCon();
      });
    },
    // 查询事件名称
    getEveName(val) {
      return new Promise((resolve) => {
        const params = {
          // deviceType:this.deviceType,
          processType: val,
          subSystem: "5",
          parkId: "200000001",
        };
        this.$fetch(api.device.vcnConfigureDeviceEunmInfo, params).then((res) => {
          resolve(res.returnObj);
        });
      });
    },
    handleUpdateAutoAlarmTask(row) {
      let autoAlarmTask = row.autoAlarmTask;
      let oldAutoAlarmTask = "1";
      if (autoAlarmTask == "1") {
        oldAutoAlarmTask = "0";
      }
      this.$confirm(`确定要${row.autoAlarmTask == "1" ? "启动" : "禁止"}吗`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const params = {
            ruleId: row.ruleId, // 事件规则ID
            autoAlarmTask: row.autoAlarmTask.toString(), // 自动任务派发 0：禁止,1：启动
          };
          this.$fetch(api.device.enableAlarmTaskRule, params).then((res) => {
            if (res.success) {
              this.$message({
                showClose: false,
                message: `自动任务派发${row.autoAlarmTask == "1" ? "启动" : "禁止"}成功`,
                type: "success",
                duration: 2000,
              });
              this.getEveCon();
            } else {
              this.$message.error(response.msgContent);
            }
          });
        })
        .catch(() => {
          row.autoAlarmTask = oldAutoAlarmTask;
        });
    },
    // 配置派发规则
    configAlarmTaskRule(row) {
      this.$refs.configAlarmTaskRuleDialog.open(row);
    },
  },
};
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";

.eventConfig-page {
  width: 100%;
  height: 100%;
  position: relative;
  .expand {
    width: calc(100% - 250px);
    height: auto;
  }
  .up {
    width: calc(100% - 250px);
    height: 41px;
    overflow: hidden;
  }
  .eventConfig-search {
    @include set_theme_color(background-color, left-menu-bg-color);
    padding: 10px 16px 3px;
    display: flex;
    align-items: center;
  }
  .el-tabs__nav {
    width: 100% !important;
    display: flex;
    justify-content: space-around;
  }
  .fire {
    .el-tabs__active-bar {
      width: 50% !important;
      transform: translateX(100%) !important;
    }
  }
  .el-tabs__active-bar {
    width: 50% !important;
  }
  .btn {
    padding: 20px;
  }
  .section-main .section-main__content .section-main__warp {
    margin: 0 0 !important;
    background-color: #22385d;
    min-height: calc(100% - 20px);
  }
  .table-container {
    height: calc(100% - 80px);
  }
}
</style>
